module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@3x-e27cfbcb26d2dd9bb98cabe774ddbce4.png";